// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"BuildControl_BuildControl__ZJ1OJ","Label":"BuildControl_Label__1TTjx","Less":"BuildControl_Less__36KXO","More":"BuildControl_More__2wpfJ"};